import PillarPlaceholder from "./PillarPlaceholder";

export default function SalesSettings() {
  return (
    <PillarPlaceholder
      pillar="sales"
      title="Sales settings"
      description="Sales-specific knobs (lead stages, quote templates, follow-up defaults) will live here once they're configurable."
    />
  );
}
